import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "form", "zone", "input", "placeholder", "preview", "previewMedia", "fileName" ]

  connect() {
    this.preventDefaults = this.preventDefaults.bind(this)
    this.zoneTarget.addEventListener("dragover", this.preventDefaults)
    this.zoneTarget.addEventListener("dragleave", this.preventDefaults)
    this.zoneTarget.addEventListener("drop", this.preventDefaults)
  }

  disconnect() {
    this.zoneTarget.removeEventListener("dragover", this.preventDefaults)
    this.zoneTarget.removeEventListener("dragleave", this.preventDefaults)
    this.zoneTarget.removeEventListener("drop", this.preventDefaults)
  }

  preventDefaults(event) {
    event.preventDefault()
    event.stopPropagation()
  }

  dragOver(event) {
    this.preventDefaults(event)
    this.zoneTarget.classList.add("active")
  }

  dragLeave(event) {
    this.preventDefaults(event)
    this.zoneTarget.classList.remove("active")
  }

  drop(event) {
    this.preventDefaults(event)
    this.zoneTarget.classList.remove("active")

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.showPreview(files[0])
    }
  }

  click(event) {
    // Let the native file input handle the click if it's the input itself
    if (event.target === this.inputTarget) return
    event.preventDefault()
    this.inputTarget.click()
  }

  inputChanged(event) {
    const file = event.target.files[0]
    if (file) {
      this.showPreview(file)
    }
  }

  showPreview(file) {
    this.fileNameTarget.textContent = file.name
    this.previewMediaTarget.innerHTML = ""

    const url = URL.createObjectURL(file)

    if (file.type.startsWith("image/")) {
      const img = document.createElement("img")
      img.src = url
      img.className = "max-h-64 w-auto object-contain"
      this.previewMediaTarget.appendChild(img)
    } else if (file.type.startsWith("video/")) {
      const video = document.createElement("video")
      video.src = url
      video.controls = true
      video.className = "max-h-64 w-auto"
      this.previewMediaTarget.appendChild(video)
    }

    this.placeholderTarget.classList.add("hidden")
    this.previewTarget.classList.remove("hidden")
  }

  clear(event) {
    event.preventDefault()
    event.stopPropagation()

    this.inputTarget.value = ""
    this.previewMediaTarget.innerHTML = ""
    this.previewTarget.classList.add("hidden")
    this.placeholderTarget.classList.remove("hidden")
  }
}
